// src/components/Bookings.js
import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../context/AuthContext";

const Bookings = () => {
  const { user } = useContext(AuthContext);
  const [bookings, setBookings] = useState([]);

  useEffect(() => {
    const fetchBookings = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get("http://localhost:5000/api/bookings", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setBookings(res.data);
      } catch (err) {
        console.error("Error fetching bookings:", err);
      }
    };

    fetchBookings();
  }, []);

  return (
    <div>
      <h2>Your Bookings</h2>
      {bookings.map((booking) => (
        <div key={booking._id} style={{ border: "1px solid #ccc", marginBottom: "10px", padding: "10px" }}>
          <p><strong>Date:</strong> {new Date(booking.date).toLocaleString()}</p>
          <p><strong>Details:</strong> {booking.details}</p>
          <p><strong>Customer:</strong> {booking.customerId?.name}</p>
          <p><strong>Provider:</strong> {booking.providerId?.name} ({booking.providerId?.role})</p>
        </div>
      ))}
    </div>
  );
};

export default Bookings;
